module.exports = __webpack_public_path__ + "4e6297134ba0c305088f7fd87f7d7223.png";